import { StyledFooter } from "../Footer/style";
export default function Footer() {
  return (
    <StyledFooter>
      <span id="title">
        <h2>TO DOs</h2>
        <h4>List</h4>
      </span>

      <h6>© 2022 - Projeto para processo seletivo.</h6>
    </StyledFooter>
  );
}
